import S from 'constants/string.const';

const actionFailed = [
  'Sorry your last action has failed.',
  'Please refresh/try again or contact Slick if it keeps happening',
].join(S.space);

const chargeInPerson = [
  "Unfortunately the client's card requires in person authentication",
  'so we are unable to charge their card at this time.',
  'Please contact them to arrange an alternative payment method',
].join(S.space);

const txCreate = [
  'Transaction failed. Any payment authorised on your client’s card via SlickPay will not be charged. ',
  '',
  'Please exit checkout, return to the calendar, and try again. If you see this message again, contact support via live chat.',
].join(S.space);

const ERROR_MESSAGE = Object.freeze({
  actionFailed,
  chargeInPerson,
  txCreate,
});

// noinspection JSUnusedGlobalSymbols
export default ERROR_MESSAGE;
